// @vue/component
export default {
  name: 'ShTextWrapperVertical',

  props: {
    text: {
      type: String,
      default: 'Some long text',
    },
    width: {
      type: String,
      default: '120px',
    },
    height: {
      type: String,
      default: '22px',
    },
    blurHeight: {
      type: String,
      default: '42%',
    },
    blurWidth: {
      type: String,
      default: '25%',
    },
  },

};
